import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppContext from './context/Context';
import toggleStylesheet from './helpers/toggleStylesheet';
import { getItemFromStore, setItemToStore, themeColors } from './helpers/utils';
import { setPageSession, clearPageSession } from './network/service';

const Main = props => {
  const [isFluid, setIsFluid] = useState(getItemFromStore('isFluid', true));
  const [isRTL, setIsRTL] = useState(getItemFromStore('isRTL', false));
  const [isDark, setIsDark] = useState(getItemFromStore('isDark', false));
  const [isTopNav, setIsTopNav] = useState(getItemFromStore('isTopNav', true));
  const [isNavbarVerticalCollapsed, setIsNavbarVerticalCollapsed] = useState(
    getItemFromStore('isNavbarVerticalCollapsed', true)
  );
  const [currency, setCurrency] = useState('$');
  const [showBurgerMenu, setShowBurgerMenu] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpenSidePanel, setIsOpenSidePanel] = useState(false);
  const toggleModal = () => setIsOpenSidePanel(prevIsOpenSidePanel => !prevIsOpenSidePanel);
  const currentPath = window.location.pathname;
  const value = {
    isRTL,
    isDark,
    isFluid,
    setIsRTL,
    isTopNav,
    currency,
    setIsDark,
    setIsFluid,
    setIsTopNav,
    setCurrency,
    toggleModal,
    showBurgerMenu,
    isOpenSidePanel,
    setShowBurgerMenu,
    setIsOpenSidePanel,
    isNavbarVerticalCollapsed,
    setIsNavbarVerticalCollapsed
  };

  const setStylesheetMode = mode => {
    setIsLoaded(false);
    setItemToStore(mode, value[mode]);
    // toggleStylesheet({ isRTL, isDark }, () => setIsLoaded(true));
  };

  useEffect(() => {
    // setItemToStore('isFluid', isFluid);
    
    if(window.location.pathname != '/login' && !currentPath.startsWith('/reset/') && window.location.pathname != '/confirm-publisher') {
      if(!localStorage.getItem('pub_id') && window.location.pathname != '/ForgotPassword' && window.location.pathname != '/confirm-publisher' && window.location.pathname != '/reset/:token') {
        
        window.location.href = '/login';
      }else if(currentPath.startsWith('/reset/')){
        const token = currentPath.split('/').pop();
      window.location.href = `/reset/${token}`;
        // window.location.href = '/reset/:token';
    }
    }
    setStylesheetMode('isFluid');
    // eslint-disable-next-line
  }, [isFluid]);

  useEffect(() => {
    setStylesheetMode('isRTL');
    // eslint-disable-next-line
  }, [isRTL]);

  useEffect(() => {
    setStylesheetMode('isDark');
    // eslint-disable-next-line
  }, [isDark]);

  useEffect(() => {
    setItemToStore('isNavbarVerticalCollapsed', isNavbarVerticalCollapsed);
    // eslint-disable-next-line
  }, [isNavbarVerticalCollapsed]);

  useEffect(() => {
    setItemToStore('isTopNav', isTopNav);
    // eslint-disable-next-line
  }, [isTopNav]);

  // Cloudflare Turnstile — invisible challenge, no package dependency
  useEffect(() => {
    const container = document.createElement('div');
    container.style.display = 'none';
    document.body.appendChild(container);
    let disposed = false;
    let widgetId;

    function renderTurnstile() {
      if (disposed || !window.turnstile || widgetId !== undefined || !container.isConnected) {
        return;
      }

      widgetId = window.turnstile.render(container, {
        sitekey:'0x4AAAAAADxS4RFYG-HLJJwP',
        size: 'invisible',
        'refresh-expired': 'auto',
        callback: async (cfToken) => {
          try {
            const resp = await fetch(
              process.env.REACT_APP_API_SERVER_HOST + '/auth/turnstile-verify',
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ cf_turnstile_token: cfToken }),
              }
            );
            const data = await resp.json();
            if (data.success) {
              setPageSession(data.page_session_token, data.expires_at);
            }
          } catch (e) {
            console.error('Page session renewal failed', e);
          }
        },
        'expired-callback': () => { clearPageSession(); },
        'error-callback': () => { clearPageSession(); },
      });
    }

    let script = document.getElementById('cf-turnstile-script');
    if (!script) {
      script = document.createElement('script');
      script.id = 'cf-turnstile-script';
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.addEventListener('load', renderTurnstile, { once: true });
      document.head.appendChild(script);
    } else if (window.turnstile) {
      renderTurnstile();
    } else {
      script.addEventListener('load', renderTurnstile, { once: true });
    }

    return () => {
      disposed = true;
      if (script) script.removeEventListener('load', renderTurnstile);
      if (widgetId !== undefined && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
      if (container.parentNode) container.parentNode.removeChild(container);
    };
  }, []);

  if (!isLoaded) {
    toggleStylesheet({ isRTL, isDark }, () => setIsLoaded(true));

    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: isDark ? themeColors.dark : themeColors.light
        }}
      />
    );
  }

  return <AppContext.Provider value={value}>{props.children}</AppContext.Provider>;
};

Main.propTypes = { children: PropTypes.node };

export default Main;
